/**
 * Formats a change in percentage points for display: +12,3% / -4% / 0%.
 * The plus sign is explicit so a rise reads as a rise without a colour cue.
 *
 * An unusable value yields an empty string rather than '0%': 'no change' is a
 * factual claim, and a broken number must not be dressed up as one. Same guard
 * as its sibling formatMonthLabel.
 *
 * @param {number} percent - change in percentage points (12.3 → '+12,3%')
 * @returns {string}
 */
const formatPercentChange = (percent) => {
    if (!Number.isFinite(percent)) return ''

    return new Intl.NumberFormat('nl-NL', {
        style: 'percent',
        signDisplay: 'exceptZero',
        maximumFractionDigits: 1,
    }).format(percent / 100)
}

export default formatPercentChange
